import { AUDIO_ASSETS, LAZY_AUDIO_ASSETS } from '../Enums/AudioAssets'
import './Components.scss';

function MusicAsset(props: {
  name: string,
  loop?: boolean,
}) {

  const asset = AUDIO_ASSETS[props.name] || LAZY_AUDIO_ASSETS[props.name] || null;
  const loop = props.loop ?? false

  if (!asset) {
    console.error(props.name + ' no asset!');
    return <></>;
  }


  return (
    <audio autoPlay loop={loop} id="myAudio">
      <source src={props.name} type="audio/mpeg" />
    </audio>
  );
}

export default MusicAsset;
